import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import { Watch } from "react-loader-spinner";
import Select from "react-select";
import axios from "axios";

const customStyles = {
  input: (base) => ({ ...base, fontWeight: 400 }),
  valueContainer: (base) => ({ ...base, fontWeight: 400 }),
};

const customRequireStyles = {
  control: (base) => ({ ...base, borderColor: "red" }),
  input: (base) => ({ ...base, fontWeight: 400 }),
  valueContainer: (base) => ({ ...base, fontWeight: 400 }),
};

const AddParty = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isError, setError] = useState(false);
  const [countryDrp, setCountryDrpData] = useState([]);
  const [stateDrp, setStateDrpData] = useState([]);
  const [cityDrp, setCityDrpData] = useState([]);
  const [formValue, setFormValue] = useState({
    id: null,
    name: "",
    city_id: "",
    state_id: "",
    address: "",
    pincode: "",
    gst_no: "",
    country_id: "",
    email: "",
    contact_no: "",
  });

  const getStateDrpData = () => {
    axios
      .post(API_URL.STATE_LIST, { country_id: formValue.country_id })
      .then((res) => {
        setStateDrpData(res.data.data);
        let cd = res.data.data.map((caw) => {
          return {
            label: caw.name,
            value: caw.id,
          };
        });
        setStateDrpData(cd);
      });
  };

  const getCountryDrpData = () => {
    axios.post(API_URL.COUNTRY_LIST, {}).then((res) => {
      setCountryDrpData(res.data.data);
      let cd = res.data.data.map((caw) => {
        return {
          label: caw.name,
          value: caw.id,
        };
      });
      setCountryDrpData(cd);
    });
  };

  const getCityDrpData = () => {
    axios
      .post(API_URL.CITY_LIST, { state_id: formValue.state_id })
      .then((res) => {
        setCityDrpData(res.data.data);
        let cd = res.data.data.map((caw) => {
          return {
            label: caw.name,
            value: caw.id,
          };
        });
        setCityDrpData(cd);
      });
  };

  const onEdit = () => {
    axios.post(API_URL.PARTY_GET, { id: id }).then((res) => {
      if (res.data.status === 1) {
        setFormValue({
          id: res.data.data.id,
          name: res.data.data.name ? res.data.data.name : "",
          city_id: res.data.data.city_id ? res.data.data.city_id : "",
          country_id: res.data.data.country_id ? res.data.data.country_id : "",
          state_id: res.data.data.state_id ? res.data.data.state_id : "",
          address: res.data.data.address ? res.data.data.address : "",
          pincode: res.data.data.pincode ? res.data.data.pincode : "",
          gst_no: res.data.data.gst_no ? res.data.data.gst_no : "",
          email: res.data.data.email ? res.data.data.email : "",
          contact_no: res.data.data.contact_no ? res.data.data.contact_no : "",
        });
      }
    });
  };

  const onSave = () => {
    if (
      formValue.name &&
      formValue.city_id &&
      formValue.country_id &&
      formValue.state_id &&
      formValue.contact_no &&
      formValue.email &&
      formValue.address &&
      formValue.pincode
    ) {
      setError(false);
      setLoading(true);
      const pUrl = id ? API_URL.PARTY_UPDATE : API_URL.PARTY_SAVE;
      axios.post(pUrl, formValue).then((res) => {
        if (res.data.status === 1) {
          let message = id
            ? "Party Updated Successfully."
            : "Party Created Successfully.";
          toast.success(message, { autoClose: 3000, position: "top-right" });
          setLoading(false);
          navigate("/admin/party");
        }
      });
    } else {
      setLoading(false);
      setError(true);
    }
  };

  const setFormData = (name, value) => {
    setFormValue({ ...formValue, [name]: value });
  };

  const isRequiredField = (key) => {
    return isError && !formValue[key];
  };

  useEffect(() => {
    getCountryDrpData();
  }, []);

  useEffect(() => {
    getStateDrpData();
  }, [formValue.country_id]);

  useEffect(() => {
    getCityDrpData();
  }, [formValue.state_id]);

  useEffect(() => {
    id && onEdit();
  }, [id]);

  return (
    <>
      <div className="page-header">
        <div className="content-page-header">
          <h5>{id ? "Update" : "Add"} Party</h5>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <form>
            <div className="row">
              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="form-group">
                  <label>
                    Name<span className="required-star">*</span>
                  </label>
                  <input
                    type="text"
                    value={formValue.name}
                    onChange={(e) => setFormData("name", e.target.value)}
                    className={
                      isRequiredField("name")
                        ? "form-control required"
                        : "form-control"
                    }
                    placeholder=""
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="form-group">
                  <label>
                    Email<span className="required-star">*</span>
                  </label>
                  <input
                    type="text"
                    value={formValue.email}
                    onChange={(e) => setFormData("email", e.target.value)}
                    placeholder=""
                    className={
                      isRequiredField("email")
                        ? "form-control required"
                        : "form-control"
                    }
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="form-group">
                  <label>
                    Mobile Number<span className="required-star">*</span>
                  </label>
                  <input
                    type="text"
                    value={formValue.contact_no}
                    onChange={(e) => setFormData("contact_no", e.target.value)}
                    placeholder=""
                    className={
                      isRequiredField("contact_no")
                        ? "form-control required"
                        : "form-control"
                    }
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="form-group">
                  <label>
                    Address<span className="required-star">*</span>
                  </label>
                  <input
                    type="text"
                    value={formValue.address}
                    onChange={(e) => setFormData("address", e.target.value)}
                    placeholder=""
                    className={
                      isRequiredField("address")
                        ? "form-control required"
                        : "form-control"
                    }
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="form-group">
                  <label htmlFor="Country">
                    Country<span className="required-star">*</span>
                  </label>
                  <Select
                    placeholder=""
                    isClearable={true}
                    styles={
                      isRequiredField("country_id")
                        ? customRequireStyles
                        : customStyles
                    }
                    options={countryDrp}
                    value={countryDrp.find(
                      (r) => r.value == formValue.country_id
                    )}
                    onChange={(e) =>
                      setFormValue({
                        ...formValue,
                        country_id: e?.value ? e.value : null,
                      })
                    }
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="form-group">
                  <label>
                    State<span className="required-star">*</span>
                  </label>
                  <Select
                    options={stateDrp}
                    isClearable={true}
                    styles={
                      isRequiredField("state_id")
                        ? customRequireStyles
                        : customStyles
                    }
                    placeholder=""
                    value={stateDrp.find((r) => r.value == formValue.state_id)}
                    onChange={(e) =>
                      setFormValue({
                        ...formValue,
                        state_id: e?.value ? e.value : null,
                      })
                    }
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="form-group">
                  <label htmlFor="City">
                    City<span className="required-star">*</span>
                  </label>
                  <Select
                    options={cityDrp}
                    isClearable={true}
                    styles={
                      isRequiredField("city_id")
                        ? customRequireStyles
                        : customStyles
                    }
                    placeholder=""
                    value={cityDrp.find((r) => r.value == formValue.city_id)}
                    onChange={(e) =>
                      setFormValue({
                        ...formValue,
                        city_id: e?.value ? e.value : null,
                      })
                    }
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="form-group">
                  <label>
                    Pincode<span className="required-star">*</span>
                  </label>
                  <input
                    type="text"
                    value={formValue.pincode}
                    onChange={(e) => setFormData("pincode", e.target.value)}
                    placeholder=""
                    className={
                      isRequiredField("pincode")
                        ? "form-control required"
                        : "form-control"
                    }
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="form-group">
                  <label>GST</label>
                  <input
                    type="text"
                    value={formValue.gst_no}
                    onChange={(e) => setFormData("gst_no", e.target.value)}
                    className="form-control"
                    placeholder=""
                  />
                </div>
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="text-end mt-3">
                  <Link
                    to={"/admin/party"}
                    className={loading ? "btn btn-danger btn-sm me-2 disabled-link" : "btn btn-danger btn-sm me-2"}
                    onClick={(e) => loading && e.preventDefault()}
                  >
                    Cancel
                  </Link>
                  <button
                    type="button"
                    onClick={onSave}
                    disabled={loading}
                    className="btn btn-primary btn-sm"
                  >
                    <div className="d-flex justify-content-center align-items-center gap-2">
                      {loading && (
                        <Watch color={"white"} height={15} width={15} />
                      )}
                      Submit
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddParty;
